export const isMissingName = (name: string | null | undefined) => !name?.trim();
